import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'María P.',
  role: 'Docente técnica de alimentos · Medellín, Colombia',
  text: '"Mis alumnos por fin entienden la diferencia entre una conserva segura y una peligrosa. Antes perdía horas buscando cómo explicar el pH y los grados Brix de forma clara. Ahora entro al taller con todo listo."'
}, {
  initials: 'JR',
  name: 'Jorge R.',
  role: 'Profesor de tecnología de alimentos · Buenos Aires, Argentina',
  text: '"Nunca más llegué a una práctica sin saber cómo explicar el proceso de curado o la diferencia entre un embutido fresco y uno madurado. El material hace el trabajo pesado por mí."'
}, {
  initials: 'SL',
  name: 'Sofía L.',
  role: 'Docente de educación técnica agropecuaria · Bogotá, Colombia',
  text: '"Las fichas técnicas con formulaciones exactas me ahorran horas cada semana. No improviso nunca más frente a mis alumnos en el taller."'
}];
export function TestimonialsStrip() {
  return <section className="py-16 bg-cream-light border-y border-cream-dark" data-id="element-393">
      <div className="max-w-7xl mx-auto px-4" data-id="element-394">
        <div className="text-center mb-10" data-id="element-395">
          <h2 className="text-2xl font-serif font-bold text-green" data-id="element-396">
            Lo que dicen docentes que ya lo tienen
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-397">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-warmwhite border border-cream-dark p-8 rounded-2xl shadow-sm relative" data-id="element-398">
              <div className="flex gap-1 text-gold mb-4" data-id="element-399">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-400" />)}
              </div>
              <p className="text-ink italic mb-6 text-sm leading-relaxed" data-id="element-401">
                {t.text}
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-402">
                <div className="w-12 h-12 rounded-full bg-cream-dark flex items-center justify-center text-green font-bold text-lg" data-id="element-403">
                  {t.initials}
                </div>
                <div data-id="element-404">
                  <div className="font-bold text-green" data-id="element-405">{t.name}</div>
                  <div className="text-xs text-terracota font-medium" data-id="element-406">
                    {t.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}